/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TreatmentContouring from './treatment-contouring';
import TreatmentContouringDetail from './treatment-contouring-detail';
import TreatmentContouringUpdate from './treatment-contouring-update';
import TreatmentContouringDeleteDialog from './treatment-contouring-delete-dialog';

const TreatmentContouringRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TreatmentContouring />} />
    <Route path="new" element={<TreatmentContouringUpdate />} />
    <Route path=":id">
      <Route index element={<TreatmentContouringDetail />} />
      <Route path="edit" element={<TreatmentContouringUpdate />} />
      <Route path="delete" element={<TreatmentContouringDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TreatmentContouringRoutes;
